import React from "react";

/**
 * Component wrapper that ensures child components are only rendered on the client side
 * This helps avoid MUI focus visibility tracking errors with window.addEventListener
 */
const ClientSideOnly = ({ children, fallback = null }) => {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  if (!isMounted) {
    return fallback;
  }

  return children;
};

export default ClientSideOnly;
